import appConf from '../app-conf'
const setup = appConf[process.env.REACT_APP_CLIENT]
const environment = process.env.NODE_ENV
const project = 'Change Password'
const server = null
const service = null
// const options = {
//   preference_options: [
//     { name: "Preference Type 1", value: "1" },
//     { name: "Preference Type 2", value: "2" }
//   ]
// };
const config = {
  details: {
    project,
    server,
    environment,
    service,
  },
  application: {
    account: {
      api: {
        endpoints: {
          resetpassword: {
            headers: {
              'Content-Type': 'application/json',
              Authorization: null,
            },
            doc: 'https://tr4ns10.tr4ns.com/Westfield-Reporting',
            //url: "/Westfield-Reporting/report21?",
            url:
              setup.setup.api.subcard.url[environment] +
              '/tx-sub/password/reset',
            method: 'POST',
          },
          auth: {
            headers: {
              'Content-Type': 'application/json',
              Authorization: null,
            },
            doc: 'http://tr4ns10.tr4ns.com/Westfield-BulkOrder/auth/auth/token',
            url: setup.setup.api.tranxactor.url[environment] + '/configs',
            method: 'POST',
          },
        },
      },
      objects: {
        password: {
          name: 'password',
          initial: '',
          placeholder: '',
          helperText: false,
          rules: [
            'isNotNull',
            'isPassword',
            'isPasswordNumber',
            'isPasswordAlpa',
            'isPasswordSpecialC',
            'isPasswordlowerC',
            'isNotThreeConsecutive',
          ],
        },
        passwordconfirm: {
          name: 'passwordconfirm',
          initial: '',
          placeholder: '',
          helperText: false,
          rules: [
            'isNotNull',
            'isPassword',
            'isPasswordNumber',
            'isPasswordAlpa',
            'isPasswordSpecialC',
            'isPasswordlowerC',
            'isNotThreeConsecutive',
            'isConfirm',
          ],
          confirm_to: 'password',
          confirm_suffix: 'password',
        },
      },
      responses: {
        fail: 'Incorrect email or password',
        unverified: 'Please verify your account by ticking the recaptcha.',
      },
    },
  },
  routes: {
    label: 'Reset Password',
    prefix: '/reset_password',
  },
  setup,
}

export default config
